import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {
  schoolId: '', //学校id
}

const actions = {
  // 学校id
  setSchoolId({commit}, id) {
    commit("SET_SCHOOL_ID", id);
  }
}
const mutations = {
  ['SET_SCHOOL_ID'](state, id) {
    Vue.set(state, 'schoolId', id);
  },
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/school.js